import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectWidgetChartEnpsDomain = (state) =>
  state.get("widgetChartEnpsV2", initialState)

export const makeSelectIsLoading = () =>
  createSelector(selectWidgetChartEnpsDomain, (state) => state.get("isLoading"))

export const makeSelectDataEnps = () =>
  createSelector(selectWidgetChartEnpsDomain, (state) => state.get("dataEnps"))

const makeSelectWidgetChartEnps = () =>
  createSelector(selectWidgetChartEnpsDomain, (substate) => substate.toJS())

export default makeSelectWidgetChartEnps
export { selectWidgetChartEnpsDomain }
